<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M24 18.6094L24 28.3894"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.556 23.5003L32 18.6113L32 28.3893L27.556 23.5003Z"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.4434 23.4603L15.9994 28.3083L15.9994 18.6113L20.4434 23.4603Z"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
